import {Pipe} from '@angular/core';

@Pipe({
  name: 'join'
})
export class JoinPipe {
  transform(array: Array<string>, sep: string) : string {
    return array.join(sep);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/join.pipe.ts